import trackingWithDom, { TrackClickData, TrackEngagementData, TrackImpressionData } from '@/utils/tracking.utils'
import { TimeEntity } from '@/webgl/runner/entities/Time'
import { ISystem } from '@/webgl/runner/interfaces/ISystem'

export default class TrackingSystem implements ISystem {
  domElement: HTMLElement

  useDomElement(element: HTMLElement): TrackingSystem {
    this.domElement = element
    return this
  }

  trackImpression(data: TrackImpressionData) {
    if (this.domElement) {
      trackingWithDom(this.domElement).trackImpression(data)
    }
  }

  trackClick(data: TrackClickData) {
    if (this.domElement) {
      trackingWithDom(this.domElement).trackClick(data)
    }
  }

  trackEngagement(data: TrackEngagementData) {
    if (this.domElement) {
      trackingWithDom(this.domElement).trackEngagement(data)
    }
  }

  update(time: TimeEntity): void {}

  dispose(): void {}
}
